import { createApp } from '@app/adapters/create-app'

import ExportIndex from '../screens/exports/components/export-index'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='exports-index']").each(function () {
    const data = this.dataset

    createApp(ExportIndex, {
      exports: JSON.parse(data.exports),
      appLinks: JSON.parse(data.applinks),
      lastMessagebusId: parseInt(data.lastmessagebusid),
      company: {
        companyId: Silverfin.currentCompanyId,
        firmId: Silverfin.currentFirmId,
      },
    }).mount(this)
  })
})
